import { Dispatch, SetStateAction, useState } from 'react';

export interface SmartAssistantRlhfHook {
  rlhfPromptText: string;
  setRlhfPromptText: Dispatch<SetStateAction<string>>;
}

export const useSmartAssistantRlhf = (): SmartAssistantRlhfHook => {
  const [rlhfPromptText, setRlhfPromptText] = useState<string>('');

  return {
    rlhfPromptText,
    setRlhfPromptText,
  };
};
